import React from 'react'

import Select from 'components/common/Select'
import Input from 'components/common/Input'
import DatePicker from 'components/common/DatePicker'

import Box from 'components_new/atoms/Box'
import Icon from 'components_new/atoms/Icon'
import IconButton from 'components_new/atoms/IconButton'
import Paper from 'components_new/atoms/Paper'

import * as Conf from '../conf'
import Styles from '../styles.module.css'

// TODO: form attributes for dashboard widgets => snake case
const Condition = ({
  remove,
  updateCondition,
  attributeOptions,
  condition
}) => {
  const dataType = attributeOptions.find(
    (attr) => attr.value === condition.leftAttribute
  )?.type

  return (
    <Paper key={`attr-${name}`} sx={{ p: 1 }} variant="outlined">
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 0.5 }}>
        <IconButton edge="end" onClick={() => remove()} size="small">
          <Icon fontSize="small" name="Close" />
        </IconButton>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Select
          size="middle"
          placeholder={'Attribut'}
          options={attributeOptions}
          value={condition.leftAttribute}
          onChange={(v) => {
            const prevAttribute = attributeOptions.find(
              (attr) => attr.value === condition.leftAttribute
            )
            const newAttribute = attributeOptions.find(
              (attr) => attr.value === v
            )

            const prevDataType = prevAttribute?.type
            const newDataType = newAttribute?.type
            const nextCondition = { ...condition, leftAttribute: v }

            if (!condition.type) {
              nextCondition.type = Conf.COLUMN
            }

            if (prevDataType !== newDataType) {
              nextCondition.type = Conf.COLUMN
              nextCondition.condition = null
              nextCondition.rightValue = null
              nextCondition.rightAttribute = null
              nextCondition.rightWidgetMetricId = null
            }

            updateCondition(nextCondition)
          }}
        />
        <Select
          size="middle"
          placeholder={'Villkor'}
          options={Conf.CONDITIONS(
            attributeOptions.find(
              (attr) => attr.value === condition.leftAttribute
            )?.type
          )}
          sorted={false}
          value={condition.condition}
          onChange={(value) => {
            const nextCondition = {
              ...condition,
              condition: value
            }

            if (Conf.ONLY_LEFT_CONDITIONS.includes(value)) {
              nextCondition.type = Conf.ONLY_LEFT
            } else if (Conf.ONLY_TEXT_CONDITIONS.includes(value)) {
              nextCondition.type = Conf.INPUT_VALUE
            } else if (condition.type === Conf.ONLY_LEFT) {
              nextCondition.type = Conf.COLUMN
            }

            updateCondition(nextCondition)
          }}
        />
        {condition &&
          condition.condition &&
          condition.type !== Conf.ONLY_LEFT &&
          dataType && (
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Box sx={{ flex: 1 }}>
              <Select
                size={'middle'}
                clearable={false}
                options={
                  Conf.ONLY_TEXT_CONDITIONS.includes(condition.condition)
                    ? [
                        {
                          value: 'INPUT_VALUE',
                          label: 'Text'
                        }
                      ]
                    : Conf.FILTER_VALUE_TYPES[dataType]
                }
                value={condition.type}
                onChange={(type) => {
                  const nextCondition = {
                    ...condition,
                    type
                  }

                  if (type !== condition.type) {
                    nextCondition.rightValue = null
                    nextCondition.rightAttribute = null
                    nextCondition.rightWidgetMetricId = null
                  }

                  updateCondition(nextCondition)
                }}
              />
            </Box>

            {
              // standard values should not have an additional value
              !Conf.STANDARD_VALUES.includes(condition.type) && (
                <Box sx={{ flex: 1 }}>
                  {condition.type === Conf.COLUMN ? (
                    <Select
                      size="middle"
                      placeholder={'Villkorsvärde'}
                      options={attributeOptions.filter((option) =>
                        Conf.TYPE_GROUPS[dataType].includes(option.type)
                      )}
                      value={condition.rightAttribute}
                      onChange={(value) => {
                        updateCondition({
                          ...condition,
                          rightAttribute: value
                        })
                      }}
                    />
                  ) : (
                    <RightValueFormItem
                      dataType={dataType}
                      value={condition.rightValue}
                      onChange={(value) => {
                        updateCondition({
                          ...condition,
                          rightValue: value
                        })
                      }}
                    />
                  )}
                </Box>
              )
            }
          </Box>
        )}
      </Box>
    </Paper>
  )
}

const RightValueFormItem = ({ dataType, value, onChange }) => {
  let inputField = (
    <Input
      size={'middle'}
      placeholder={'Villkorsvärde'}
      value={value}
      onChange={onChange}
    />
  )

  if (Conf.isDate(dataType)) {
    inputField = (
      <DatePicker
        size={'middle'}
        className={Styles['filter-operation-date-picker']}
        ignoreLockedMode
        value={value}
        onChange={onChange}
      />
    )
  }

  return inputField
}

export default Condition
